export default __webpack_public_path__ + "static/media/news-3.235daca1.jpg";